import { useCallback } from 'react';

import { useUpgradePopup } from 'src/views/UpgradePopup';

export const useHandlers = ({ upgradeActionOrigin, feature }) => {
  const openUpgradePopup = useUpgradePopup({ actionsOrigin: upgradeActionOrigin });

  const handleUpgradeClick = useCallback(() => {
    openUpgradePopup(feature);
  }, [openUpgradePopup, feature]);

  return {
    handleUpgradeClick,
  };
};
